import { InfoCircleOutlined, ExperimentOutlined, RocketOutlined, ReloadOutlined } from '@ant-design/icons'
import { Alert, App, Button, Card, Checkbox, Input, Select, Space, Tag, Typography, Descriptions, Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ContainerFull } from '../components/GeneralComponents'
import { pingMinKnowServer, getPositions, getProtocolRunInfo, getAcquisitionInfo, getFlowCellInfo, getFlowCells, getBasecallConfigs, startProtocol, stopProtocol, stopAcquisition, updateRunUntil, getChannelStates } from '../endpoints'
import minnowImage from '../images/minnow.webp'

const { Title, Text } = Typography

interface ServerData {
    loading: boolean
    error: string | null
    hostInfo: any
    positions: any
    protocol: any
    acquisition: any
    flowcell: any
    flowcellCheckProgress: any
    flowcellCheckLoading: boolean
    flowcellCheckError: string | null
}

export const MinKnow = (): JSX.Element => {
    const { message, modal } = App.useApp()
    const [activeTab, setActiveTab] = useState<'a6000' | 'mk1c' | 'outpond' | 'sierra'>('a6000')
    
    // a6000 state
    const [dataA6000, setDataA6000] = useState<ServerData>({
        loading: false,
        error: null,
        hostInfo: null,
        positions: null,
        protocol: null,
        acquisition: null,
        flowcell: null,
        flowcellCheckProgress: null,
        flowcellCheckLoading: false,
        flowcellCheckError: null
    })
    const [rbkRunIdA6000, setRbkRunIdA6000] = useState<string>('')
    const [rbkHoursA6000, setRbkHoursA6000] = useState<string>('')
    const [basecallConfigsA6000, setBasecallConfigsA6000] = useState<any>(null)
    const [basecallConfigsLoadingA6000, setBasecallConfigsLoadingA6000] = useState<boolean>(false)
    
    // mk1c state
    const [dataMk1c, setDataMk1c] = useState<ServerData>({
        loading: false,
        error: null,
        hostInfo: null,
        positions: null,
        protocol: null,
        acquisition: null,
        flowcell: null,
        flowcellCheckProgress: null,
        flowcellCheckLoading: false,
        flowcellCheckError: null
    })
    const [rbkRunIdMk1c, setRbkRunIdMk1c] = useState<string>('')
    const [rbkHoursMk1c, setRbkHoursMk1c] = useState<string>('')
    const [basecallConfigsMk1c, setBasecallConfigsMk1c] = useState<any>(null)
    const [basecallConfigsLoadingMk1c, setBasecallConfigsLoadingMk1c] = useState<boolean>(false)
    
    // outpond state
    const [dataOutpond, setDataOutpond] = useState<ServerData>({
        loading: false,
        error: null,
        hostInfo: null,
        positions: null,
        protocol: null,
        acquisition: null,
        flowcell: null,
        flowcellCheckProgress: null,
        flowcellCheckLoading: false,
        flowcellCheckError: null
    })
    const [rbkRunIdOutpond, setRbkRunIdOutpond] = useState<string>('')
    const [rbkHoursOutpond, setRbkHoursOutpond] = useState<string>('')
    const [basecallConfigsOutpond, setBasecallConfigsOutpond] = useState<any>(null)
    const [basecallConfigsLoadingOutpond, setBasecallConfigsLoadingOutpond] = useState<boolean>(false)

    // sierra state
    const [dataSierra, setDataSierra] = useState<ServerData>({
        loading: false,
        error: null,
        hostInfo: null,
        positions: null,
        protocol: null,
        acquisition: null,
        flowcell: null,
        flowcellCheckProgress: null,
        flowcellCheckLoading: false,
        flowcellCheckError: null
    })
    const [rbkRunIdSierra, setRbkRunIdSierra] = useState<string>('')
    const [rbkHoursSierra, setRbkHoursSierra] = useState<string>('')
    const [basecallConfigsSierra, setBasecallConfigsSierra] = useState<any>(null)
    const [basecallConfigsLoadingSierra, setBasecallConfigsLoadingSierra] = useState<boolean>(false)

    // Channel states state
    const [channelStatesA6000, setChannelStatesA6000] = useState<any>(null)
    const [channelStatesLoadingA6000, setChannelStatesLoadingA6000] = useState<boolean>(false)
    const [channelStatesMk1c, setChannelStatesMk1c] = useState<any>(null)
    const [channelStatesLoadingMk1c, setChannelStatesLoadingMk1c] = useState<boolean>(false)
    const [channelStatesOutpond, setChannelStatesOutpond] = useState<any>(null)
    const [channelStatesLoadingOutpond, setChannelStatesLoadingOutpond] = useState<boolean>(false)
    const [channelStatesSierra, setChannelStatesSierra] = useState<any>(null)
    const [channelStatesLoadingSierra, setChannelStatesLoadingSierra] = useState<boolean>(false)

    // Run-until update state
    const [runUntilHoursA6000, setRunUntilHoursA6000] = useState<string>('')
    const [runUntilHoursMk1c, setRunUntilHoursMk1c] = useState<string>('')
    const [runUntilHoursOutpond, setRunUntilHoursOutpond] = useState<string>('')
    const [runUntilHoursSierra, setRunUntilHoursSierra] = useState<string>('')

    // Run-until position selection state
    const [runUntilPositionA6000, setRunUntilPositionA6000] = useState<string>('')
    const [runUntilPositionMk1c, setRunUntilPositionMk1c] = useState<string>('')
    const [runUntilPositionOutpond, setRunUntilPositionOutpond] = useState<string>('')
    const [runUntilPositionSierra, setRunUntilPositionSierra] = useState<string>('')

    // RBK position selection state
    const [rbkPositionA6000, setRbkPositionA6000] = useState<string>('')
    const [rbkPositionMk1c, setRbkPositionMk1c] = useState<string>('')
    const [rbkPositionOutpond, setRbkPositionOutpond] = useState<string>('')
    const [rbkPositionSierra, setRbkPositionSierra] = useState<string>('')

    // Stop protocol position selection state
    const [stopPositionA6000, setStopPositionA6000] = useState<string>('')
    const [stopPositionMk1c, setStopPositionMk1c] = useState<string>('')
    const [stopPositionOutpond, setStopPositionOutpond] = useState<string>('')
    const [stopPositionSierra, setStopPositionSierra] = useState<string>('')

    // Test flowcell position selection state
    const [testFlowcellPositionA6000, setTestFlowcellPositionA6000] = useState<string>('')
    const [testFlowcellPositionMk1c, setTestFlowcellPositionMk1c] = useState<string>('')
    const [testFlowcellPositionOutpond, setTestFlowcellPositionOutpond] = useState<string>('')
    const [testFlowcellPositionSierra, setTestFlowcellPositionSierra] = useState<string>('')

    // Flowcell check progress position selection state
    const [checkProgressPositionA6000, setCheckProgressPositionA6000] = useState<string>('')
    const [checkProgressPositionMk1c, setCheckProgressPositionMk1c] = useState<string>('')
    const [checkProgressPositionOutpond, setCheckProgressPositionOutpond] = useState<string>('')
    const [checkProgressPositionSierra, setCheckProgressPositionSierra] = useState<string>('')

    const updateData = (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra', updates: Partial<ServerData>) => {
        if (serverId === 'a6000') {
            setDataA6000(prev => ({ ...prev, ...updates }))
        } else if (serverId === 'mk1c') {
            setDataMk1c(prev => ({ ...prev, ...updates }))
        } else if (serverId === 'outpond') {
            setDataOutpond(prev => ({ ...prev, ...updates }))
        } else {
            setDataSierra(prev => ({ ...prev, ...updates }))
        }
    }

    const getData = (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        return serverId === 'a6000' ? dataA6000 : serverId === 'mk1c' ? dataMk1c : serverId === 'outpond' ? dataOutpond : dataSierra
    }

    const handleGetHostInfo = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        updateData(serverId, { loading: true, error: null, hostInfo: null, positions: null, protocol: null, acquisition: null, flowcell: null })
        try {

            const result = await pingMinKnowServer(serverId)
            if (result.code === 0) {
                updateData(serverId, { loading: false, hostInfo: result.hostInfo })
            } else {
                updateData(serverId, { loading: false, error: result.message || 'Failed to get host info' })
            }
            // console.log('Host info for server', serverId, ':', result.hostInfo)
        } catch (err) {
            updateData(serverId, { loading: false, error: 'Connection failed' })
        }
    }

    const handleGetPositions = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        updateData(serverId, { loading: true, error: null, positions: null, hostInfo: null, protocol: null, acquisition: null, flowcell: null })
        try {
            const result = await getPositions(serverId)
            if (result.code === 0) {
                updateData(serverId, { loading: false, positions: result.positions })
            } else {
                updateData(serverId, { loading: false, error: result.message || 'Failed to get positions' })
            }
        } catch (err) {
            updateData(serverId, { loading: false, error: 'Failed to get positions' })
        }
    }

    const handleGetProtocol = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        updateData(serverId, { loading: true, error: null, protocol: null, hostInfo: null, acquisition: null, flowcell: null })
        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available')
            }

            const allProtocols: any[] = []
            for (const pos of posResult.positions) {
                const result = await getProtocolRunInfo(serverId, pos.name)
                if (result.code === 0) {
                    allProtocols.push({ ...result.data, positionName: pos.name })
                }
            }

            updateData(serverId, { loading: false, protocol: allProtocols })
        } catch (err: any) {
            updateData(serverId, { loading: false, error: err.message || 'Failed to get protocol info' })
        }
    }

    const handleGetAcquisition = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        updateData(serverId, { loading: true, error: null, acquisition: null, hostInfo: null, protocol: null, flowcell: null })
        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available')
            }

            const allAcquisitions: any[] = []
            for (const pos of posResult.positions) {
                const result = await getAcquisitionInfo(serverId, pos.name)
                if (result.code === 0) {
                    allAcquisitions.push({ ...result.data, positionName: pos.name })
                }
            }

            updateData(serverId, { loading: false, acquisition: allAcquisitions })
        } catch (err: any) {
            updateData(serverId, { loading: false, error: err.message || 'Failed to get acquisition info' })
        }
    }

    const handleGetFlowcell = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        updateData(serverId, { loading: true, error: null, flowcell: null, hostInfo: null, protocol: null, acquisition: null })
        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available')
            }

            // Fetch database flowcells once for ID lookups
            let dbFlowcells: any[] = []
            try {
                const dbResult = await getFlowCells()
                if (dbResult.code === 1000 && dbResult.flowcells) {
                    dbFlowcells = dbResult.flowcells
                }
            } catch (dbErr) {
                console.error('Failed to fetch database flowcell info:', dbErr)
            }

            const allFlowcells: any[] = []
            for (const pos of posResult.positions) {
                const result = await getFlowCellInfo(serverId, pos.name)
                if (result.code === 0) {
                    let flowcellData = { ...result.data, positionName: pos.name }
                    if (flowcellData.flow_cell_id) {
                        const dbFlowcell = dbFlowcells.find(fc => fc.name === flowcellData.flow_cell_id)
                        if (dbFlowcell) {
                            flowcellData = { ...flowcellData, dbFlowcellId: dbFlowcell.id }
                        }
                    }
                    allFlowcells.push(flowcellData)
                }
            }

            updateData(serverId, { loading: false, flowcell: allFlowcells })
        } catch (err: any) {
            updateData(serverId, { loading: false, error: err.message || 'Failed to get flowcell info' })
        }
    }

    const handleGetChannelStates = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        if (serverId === 'a6000') setChannelStatesLoadingA6000(true)
        else if (serverId === 'mk1c') setChannelStatesLoadingMk1c(true)
        else if (serverId === 'outpond') setChannelStatesLoadingOutpond(true)
        else setChannelStatesLoadingSierra(true)

        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available')
            }

            const allChannelStates: any[] = []
            for (const pos of posResult.positions) {
                const result = await getChannelStates(serverId, pos.name)
                if (result.code === 0) {
                    allChannelStates.push({ ...result.data, positionName: pos.name })
                }
            }

            if (serverId === 'a6000') { setChannelStatesA6000(allChannelStates); setChannelStatesLoadingA6000(false) }
            else if (serverId === 'mk1c') { setChannelStatesMk1c(allChannelStates); setChannelStatesLoadingMk1c(false) }
            else if (serverId === 'outpond') { setChannelStatesOutpond(allChannelStates); setChannelStatesLoadingOutpond(false) }
            else { setChannelStatesSierra(allChannelStates); setChannelStatesLoadingSierra(false) }
        } catch (err: any) {
            if (serverId === 'a6000') setChannelStatesLoadingA6000(false)
            else if (serverId === 'mk1c') setChannelStatesLoadingMk1c(false)
            else if (serverId === 'outpond') setChannelStatesLoadingOutpond(false)
            else setChannelStatesLoadingSierra(false)
            message.error(err.message || 'Failed to fetch channel states')
        }
    }

    const handleGetBasecallConfigs = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        if (serverId === 'a6000') {
            setBasecallConfigsLoadingA6000(true)
        } else if (serverId === 'mk1c') {
            setBasecallConfigsLoadingMk1c(true)
        } else if (serverId === 'outpond') {
            setBasecallConfigsLoadingOutpond(true)
        } else {
            setBasecallConfigsLoadingSierra(true)
        }

        try {
            const result = await getBasecallConfigs(serverId)
            
            if (result.code === 0) {
                if (serverId === 'a6000') {
                    setBasecallConfigsA6000(result.data)
                    setBasecallConfigsLoadingA6000(false)
                } else if (serverId === 'mk1c') {
                    setBasecallConfigsMk1c(result.data)
                    setBasecallConfigsLoadingMk1c(false)
                } else if (serverId === 'outpond') {
                    setBasecallConfigsOutpond(result.data)
                    setBasecallConfigsLoadingOutpond(false)
                } else {
                    setBasecallConfigsSierra(result.data)
                    setBasecallConfigsLoadingSierra(false)
                }
                message.success('Basecall configurations loaded')
            } else {
                throw new Error(result.message || 'Failed to fetch basecall configs')
            }
        } catch (err: any) {
            if (serverId === 'a6000') {
                setBasecallConfigsLoadingA6000(false)
            } else if (serverId === 'mk1c') {
                setBasecallConfigsLoadingMk1c(false)
            } else if (serverId === 'outpond') {
                setBasecallConfigsLoadingOutpond(false)
            } else {
                setBasecallConfigsLoadingSierra(false)
            }
            message.error(err.message || 'Failed to fetch basecall configs')
        }
    }

    const handleFlowcellCheckProgress = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const selectedPosition = serverId === 'a6000' ? checkProgressPositionA6000 : serverId === 'mk1c' ? checkProgressPositionMk1c : serverId === 'outpond' ? checkProgressPositionOutpond : checkProgressPositionSierra
        updateData(serverId, { flowcellCheckLoading: true, flowcellCheckError: null, flowcellCheckProgress: null })

        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available on device')
            }

            const chosenPosition = selectedPosition || posResult.positions[0].name

            // Get protocol run info to check for flowcell check
            const runInfo = await getProtocolRunInfo(serverId, chosenPosition)
            
            // Check if it's a flowcell check protocol
            if (!runInfo.data?.protocol_id || !runInfo.data.protocol_id.includes('flowcell_check')) {
                throw new Error('No flowcell check protocol is currently running or completed on this device')
            }

            updateData(serverId, { flowcellCheckLoading: false, flowcellCheckProgress: runInfo.data })
        } catch (err: any) {
            updateData(serverId, { flowcellCheckLoading: false, flowcellCheckError: err?.message || 'Failed to get flowcell check progress' })
        }
    }

    const handleFlowcellTest = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const selectedPosition = serverId === 'a6000' ? testFlowcellPositionA6000 : serverId === 'mk1c' ? testFlowcellPositionMk1c : serverId === 'outpond' ? testFlowcellPositionOutpond : testFlowcellPositionSierra
        modal.confirm({
            title: 'Start Flowcell Check',
            content: 'Are you sure you want to start the flowcell check? This will start a test protocol.',
            onOk: async () => {
                const hide = message.loading('Starting flowcell check...', 0)
                try {
                    const posResult = await getPositions(serverId)
                    if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                        throw new Error('No positions available')
                    }

                    const chosenPosition = selectedPosition || posResult.positions[0].name

                    const flowcellResult = await getFlowCellInfo(serverId, chosenPosition)
                    if (flowcellResult.code !== 0 || !flowcellResult.data?.flow_cell_id) {
                        throw new Error('No flowcell detected in position')
                    }

                    const result = await startProtocol(serverId, chosenPosition, {
                        identifier: 'checks/flowcell_check/platform_qc_R10_4:FLO-MIN114'
                    })
                    
                    if (result.code !== 0) throw new Error(result.message || 'Failed to start flowcell check')
                    
                    hide()
                    message.success('Flowcell check started successfully')
                    handleGetProtocol(serverId)
                } catch (err: any) {
                    hide()
                    message.error(err.message || 'Failed to start flowcell check')
                }
            }
        })
    }

    const handleStopProtocol = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const selectedPosition = serverId === 'a6000' ? stopPositionA6000 : serverId === 'mk1c' ? stopPositionMk1c : serverId === 'outpond' ? stopPositionOutpond : stopPositionSierra
        modal.confirm({
            title: 'Stop Protocol',
            content: 'Are you sure you want to stop the current protocol?',
            okType: 'danger',
            onOk: async () => {
                const hide = message.loading('Stopping protocol...', 0)
                try {
                    const posResult = await getPositions(serverId)
                    if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                        throw new Error('No positions available')
                    }

                    const chosenPosition = selectedPosition || posResult.positions[0].name

                    const protocolResult = await getProtocolRunInfo(serverId, chosenPosition)
                    if (protocolResult.code !== 0 || !protocolResult.data?.run_id) {
                        throw new Error('No active protocol found')
                    }

                    const runId = protocolResult.data.run_id

                    const result = await stopProtocol(serverId, chosenPosition, runId)

                    if (result.code !== 0) throw new Error(result.message || 'Failed to stop protocol')

                    hide()
                    message.success('Protocol stopped successfully')
                    handleGetProtocol(serverId)
                } catch (err: any) {
                    hide()
                    message.error(err.message || 'Failed to stop protocol')
                }
            }
        })
    }

    const handleUpdateRunUntil = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const hoursInput = serverId === 'a6000' ? runUntilHoursA6000 : serverId === 'mk1c' ? runUntilHoursMk1c : serverId === 'outpond' ? runUntilHoursOutpond : runUntilHoursSierra
        const selectedPosition = serverId === 'a6000' ? runUntilPositionA6000 : serverId === 'mk1c' ? runUntilPositionMk1c : serverId === 'outpond' ? runUntilPositionOutpond : runUntilPositionSierra
        const hours = parseFloat(hoursInput)
        
        if (isNaN(hours) || hours <= 0) {
            message.error('Please enter a valid number of hours (e.g., 3, 3.5, 4)')
            return
        }

        const hide = message.loading('Updating run-until criteria...', 0)
        try {
            const posResult = await getPositions(serverId)
            if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                throw new Error('No positions available')
            }

            const chosenPosition = selectedPosition || posResult.positions[0].name
            const seconds = Math.floor(hours * 3600)

            const result = await updateRunUntil(serverId, chosenPosition, seconds)
            
            if (result.code !== 0) {
                throw new Error(result.message || 'Failed to update run-until criteria')
            }
            
            hide()
            message.success(`Run-until criteria updated to ${hours} hours for position ${chosenPosition}`)
            
            // Clear input and refresh acquisition info
            if (serverId === 'a6000') {
                setRunUntilHoursA6000('')
            } else if (serverId === 'mk1c') {
                setRunUntilHoursMk1c('')
            } else if (serverId === 'outpond') {
                setRunUntilHoursOutpond('')
            } else {
                setRunUntilHoursSierra('')
            }
            handleGetAcquisition(serverId)
        } catch (err: any) {
            hide()
            message.error(err.message || 'Failed to update run-until criteria')
        }
    }

    const handleStartRbkRun = async (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const runIdTrimmed = serverId === 'a6000' ? rbkRunIdA6000.trim() : serverId === 'mk1c' ? rbkRunIdMk1c.trim() : serverId === 'outpond' ? rbkRunIdOutpond.trim() : rbkRunIdSierra.trim()
        const hours = parseFloat(serverId === 'a6000' ? rbkHoursA6000 : serverId === 'mk1c' ? rbkHoursMk1c : serverId === 'outpond' ? rbkHoursOutpond : rbkHoursSierra)
        
        if (!runIdTrimmed) {
            message.error('Please enter a Run ID')
            return
        }
        
        if (isNaN(hours) || hours <= 0) {
            message.error('Please enter a valid number of hours (e.g., 3, 3.5, 4)')
            return
        }

        const selectedPosition = serverId === 'a6000' ? rbkPositionA6000 : serverId === 'mk1c' ? rbkPositionMk1c : serverId === 'outpond' ? rbkPositionOutpond : rbkPositionSierra

        modal.confirm({
            title: 'Start RBK Sequencing Run',
            content: (
                <>
                    <p><strong>Run ID:</strong> {runIdTrimmed}</p>
                    <p><strong>Duration:</strong> {hours} hours</p>
                    {selectedPosition && <p><strong>Position:</strong> {selectedPosition}</p>}
                    <p><strong>Output:</strong> /data/plab/runs</p>
                </>
            ),
            onOk: async () => {
                const hide = message.loading('Starting RBK run...', 0)
                try {
                    const posResult = await getPositions(serverId)
                    if (posResult.code !== 0 || !posResult.positions || posResult.positions.length === 0) {
                        throw new Error('No positions available')
                    }

                    const chosenPosition = selectedPosition || posResult.positions[0].name
                    const positionExists = posResult.positions.some((p: any) => p.name === chosenPosition)
                    if (!positionExists) throw new Error(`Position "${chosenPosition}" not found`)
                    
                    const firstPosition = chosenPosition
                    
                    const flowcellResult = await getFlowCellInfo(serverId, firstPosition)
                    if (flowcellResult.code !== 0 || !flowcellResult.data?.flow_cell_id) {
                        throw new Error('No flowcell detected in position')
                    }

                    const protocolResult = await getProtocolRunInfo(serverId, firstPosition)
                    const protocolState = protocolResult.data?.state ?? protocolResult.data?.protocol_state
                    if (protocolState === 'PROTOCOL_RUNNING') {
                        throw new Error('Cannot start run: A protocol is already running on this flowcell. Please stop the current protocol first.')
                    }

                    const args = [
                        '--pod5=on',
                        '--fast5=off',
                        '--fastq=off',
                        '--bam=off',
                        '--base_calling=off'
                    ]

                    const result = await startProtocol(serverId, firstPosition, {
                        identifier: 'sequencing/sequencing_MIN114_DNA_e8_2_400K:FLO-MIN114:SQK-RBK114-96:400',
                        experiment_group_id: runIdTrimmed,
                        disable_active_channel_selection: false,
                        mux_scan_period: 1.5,
                        target_run_until_criteria: {
                            stop_criteria: {
                                criteria: {
                                    runtime: {
                                        "@type": "type.googleapis.com/google.protobuf.UInt64Value",
                                        "value": String(Math.floor(hours * 3600))
                                    }
                                }
                            }
                        },
                        writer_configuration: {
                            read_pod5_config: {
                                reads_per_file: 5000
                            }
                        },
                        args
                    })
                    
                    if (result.code !== 0) throw new Error(result.message || 'Failed to start RBK run')
                    
                    hide()
                    message.success('RBK sequencing run started successfully')
                    if (serverId === 'a6000') {
                        setRbkRunIdA6000('')
                        setRbkHoursA6000('')
                    } else if (serverId === 'mk1c') {
                        setRbkRunIdMk1c('')
                        setRbkHoursMk1c('')
                    } else if (serverId === 'outpond') {
                        setRbkRunIdOutpond('')
                        setRbkHoursOutpond('')
                    } else {
                        setRbkRunIdSierra('')
                        setRbkHoursSierra('')
                    }
                    handleGetProtocol(serverId)
                } catch (err: any) {
                    hide()
                    message.error(err.message || 'Failed to start RBK run')
                }
            }
        })
    }

    const renderServerTab = (serverId: 'a6000' | 'mk1c' | 'outpond' | 'sierra') => {
        const data = getData(serverId)
        const protocolStates: string[] = Array.isArray(data.protocol)
            ? data.protocol.map((p: any) => p.state ?? p.protocol_state).filter(Boolean)
            : []
        const protocolRunning = protocolStates.some(s => s === 'PROTOCOL_RUNNING')
        const acquisitionRunning = Array.isArray(data.acquisition)
            ? data.acquisition.some((a: any) => a.state === 'ACQUISITION_RUNNING')
            : data.acquisition?.state === 'ACQUISITION_RUNNING'
        const positionProtocolRunning = data.positions?.some((pos: any) => pos.protocol_state === 'PROTOCOL_RUNNING')
        const isRunning = protocolRunning || acquisitionRunning || positionProtocolRunning

        const runUntilHours = serverId === 'a6000' ? runUntilHoursA6000 : serverId === 'mk1c' ? runUntilHoursMk1c : serverId === 'outpond' ? runUntilHoursOutpond : runUntilHoursSierra
        const setRunUntilHours = serverId === 'a6000' ? setRunUntilHoursA6000 : serverId === 'mk1c' ? setRunUntilHoursMk1c : serverId === 'outpond' ? setRunUntilHoursOutpond : setRunUntilHoursSierra
        const runUntilPosition = serverId === 'a6000' ? runUntilPositionA6000 : serverId === 'mk1c' ? runUntilPositionMk1c : serverId === 'outpond' ? runUntilPositionOutpond : runUntilPositionSierra
        const setRunUntilPosition = serverId === 'a6000' ? setRunUntilPositionA6000 : serverId === 'mk1c' ? setRunUntilPositionMk1c : serverId === 'outpond' ? setRunUntilPositionOutpond : setRunUntilPositionSierra
        const rbkRunId = serverId === 'a6000' ? rbkRunIdA6000 : serverId === 'mk1c' ? rbkRunIdMk1c : serverId === 'outpond' ? rbkRunIdOutpond : rbkRunIdSierra
        const setRbkRunId = serverId === 'a6000' ? setRbkRunIdA6000 : serverId === 'mk1c' ? setRbkRunIdMk1c : serverId === 'outpond' ? setRbkRunIdOutpond : setRbkRunIdSierra
        const rbkHours = serverId === 'a6000' ? rbkHoursA6000 : serverId === 'mk1c' ? rbkHoursMk1c : serverId === 'outpond' ? rbkHoursOutpond : rbkHoursSierra
        const setRbkHours = serverId === 'a6000' ? setRbkHoursA6000 : serverId === 'mk1c' ? setRbkHoursMk1c : serverId === 'outpond' ? setRbkHoursOutpond : setRbkHoursSierra
        const rbkPosition = serverId === 'a6000' ? rbkPositionA6000 : serverId === 'mk1c' ? rbkPositionMk1c : serverId === 'outpond' ? rbkPositionOutpond : rbkPositionSierra
        const setRbkPosition = serverId === 'a6000' ? setRbkPositionA6000 : serverId === 'mk1c' ? setRbkPositionMk1c : serverId === 'outpond' ? setRbkPositionOutpond : setRbkPositionSierra
        const stopPosition = serverId === 'a6000' ? stopPositionA6000 : serverId === 'mk1c' ? stopPositionMk1c : serverId === 'outpond' ? stopPositionOutpond : stopPositionSierra
        const setStopPosition = serverId === 'a6000' ? setStopPositionA6000 : serverId === 'mk1c' ? setStopPositionMk1c : serverId === 'outpond' ? setStopPositionOutpond : setStopPositionSierra
        const testFlowcellPosition = serverId === 'a6000' ? testFlowcellPositionA6000 : serverId === 'mk1c' ? testFlowcellPositionMk1c : serverId === 'outpond' ? testFlowcellPositionOutpond : testFlowcellPositionSierra
        const setTestFlowcellPosition = serverId === 'a6000' ? setTestFlowcellPositionA6000 : serverId === 'mk1c' ? setTestFlowcellPositionMk1c : serverId === 'outpond' ? setTestFlowcellPositionOutpond : setTestFlowcellPositionSierra
        const checkProgressPosition = serverId === 'a6000' ? checkProgressPositionA6000 : serverId === 'mk1c' ? checkProgressPositionMk1c : serverId === 'outpond' ? checkProgressPositionOutpond : checkProgressPositionSierra
        const setCheckProgressPosition = serverId === 'a6000' ? setCheckProgressPositionA6000 : serverId === 'mk1c' ? setCheckProgressPositionMk1c : serverId === 'outpond' ? setCheckProgressPositionOutpond : setCheckProgressPositionSierra
        const availablePositions: string[] = (data.positions ?? []).filter((p: any) => p.state !== 'STATE_HARDWARE_REMOVED').map((p: any) => p.name)

        return (
            <>
                {protocolStates.length > 0 && (
                    <Alert
                        message={`Protocol State: ${protocolStates.join(' | ')}`}
                        type={isRunning ? 'success' : 'info'}
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                )}

                <Space wrap style={{ marginBottom: 16 }}>
                    <Button
                        icon={<InfoCircleOutlined />}
                        onClick={() => handleGetHostInfo(serverId)}
                        loading={data.loading}
                    >
                        Host Info
                    </Button>
                    <Button
                        onClick={() => handleGetPositions(serverId)}
                        loading={data.loading}
                    >
                        List Positions
                    </Button>
                    <Button
                        onClick={() => handleGetFlowcell(serverId)}
                        loading={data.loading}
                    >
                        Flowcell Info
                    </Button>
                    <Button
                        onClick={() => handleGetProtocol(serverId)}
                        loading={data.loading}
                    >
                        Protocol Info
                    </Button>
                    <Button
                        className="acquisition-info-btn"
                        onClick={() => handleGetAcquisition(serverId)}
                        loading={data.loading}
                    >
                        Acquisition Info
                    </Button>
                    <Button
                        onClick={() => handleGetChannelStates(serverId)}
                        loading={serverId === 'a6000' ? channelStatesLoadingA6000 : serverId === 'mk1c' ? channelStatesLoadingMk1c : serverId === 'outpond' ? channelStatesLoadingOutpond : channelStatesLoadingSierra}
                    >
                        Channel States
                    </Button>
                   
                    {availablePositions.length > 1 ? (
                        <Space.Compact>
                            <Select
                                placeholder="Select position"
                                value={testFlowcellPosition || undefined}
                                onChange={(v) => setTestFlowcellPosition(v)}
                                style={{ minWidth: 160 }}
                                options={availablePositions.map(p => ({ label: p, value: p }))}
                            />
                            <Button
                                type="primary"
                                icon={<ExperimentOutlined />}
                                onClick={() => handleFlowcellTest(serverId)}
                                disabled={isRunning || data.loading || !testFlowcellPosition}
                            >
                                Test Flowcell
                            </Button>
                        </Space.Compact>
                    ) : (
                        <Button
                            type="primary"
                            icon={<ExperimentOutlined />}
                            onClick={() => handleFlowcellTest(serverId)}
                            disabled={isRunning || data.loading}
                        >
                            Test Flowcell
                        </Button>
                    )}
                    {availablePositions.length > 1 ? (
                        <Space.Compact>
                            <Select
                                placeholder="Select position"
                                value={checkProgressPosition || undefined}
                                onChange={(v) => setCheckProgressPosition(v)}
                                style={{ minWidth: 160 }}
                                options={availablePositions.map(p => ({ label: p, value: p }))}
                            />
                            <Button
                                type="default"
                                onClick={() => handleFlowcellCheckProgress(serverId)}
                                loading={data.flowcellCheckLoading}
                                disabled={!checkProgressPosition}
                                style={{ backgroundColor: '#17a2b8', color: 'white', borderColor: '#17a2b8' }}
                            >
                                Show Flowcell Check Progress
                            </Button>
                        </Space.Compact>
                    ) : (
                        <Button
                            type="default"
                            onClick={() => handleFlowcellCheckProgress(serverId)}
                            loading={data.flowcellCheckLoading}
                            style={{ backgroundColor: '#17a2b8', color: 'white', borderColor: '#17a2b8' }}
                        >
                            Show Flowcell Check Progress
                        </Button>
                    )}
                    {availablePositions.length > 1 ? (
                        <Space.Compact>
                            <Select
                                placeholder="Select position"
                                value={stopPosition || undefined}
                                onChange={(v) => setStopPosition(v)}
                                style={{ minWidth: 160 }}
                                options={availablePositions.map(p => ({ label: p, value: p }))}
                            />
                            <Button
                                danger
                                onClick={() => handleStopProtocol(serverId)}
                                disabled={data.loading || !stopPosition}
                            >
                                Stop Protocol
                            </Button>
                        </Space.Compact>
                    ) : (
                        <Button
                            danger
                            onClick={() => handleStopProtocol(serverId)}
                            disabled={data.loading}
                        >
                            Stop Protocol
                        </Button>
                    )}
                     <Button
                        onClick={() => handleGetBasecallConfigs(serverId)}
                        loading={serverId === 'a6000' ? basecallConfigsLoadingA6000 : serverId === 'mk1c' ? basecallConfigsLoadingMk1c : serverId === 'outpond' ? basecallConfigsLoadingOutpond : basecallConfigsLoadingSierra}
                    >
                        List Basecall Models
                    </Button>
                </Space>

                <Card title="Start RBK Sequencing Run" size="small" style={{ marginBottom: 16 }}>
                    <Space.Compact style={{ width: '100%', marginBottom: 8 }}>
                        <Input
                            placeholder="Run ID (e.g., run001)"
                            value={rbkRunId}
                            onChange={(e) => setRbkRunId(e.target.value)}
                            style={{ width: '200px' }}
                        />
                        <Input
                            type="number"
                            placeholder="Hours (e.g., 4)"
                            value={rbkHours}
                            onChange={(e) => setRbkHours(e.target.value)}
                            style={{ width: '150px' }}
                        />
                        {availablePositions.length > 1 && (
                            <Select
                                placeholder="Select position"
                                value={rbkPosition || undefined}
                                onChange={(val) => setRbkPosition(val)}
                                style={{ width: '160px' }}
                                options={availablePositions.map((p) => ({ label: p, value: p }))}
                            />
                        )}
                        <Button
                            type="primary"
                            icon={<RocketOutlined />}
                            onClick={() => handleStartRbkRun(serverId)}
                            disabled={isRunning || data.loading || (availablePositions.length > 1 && !rbkPosition)}
                        >
                            Start RBK Run
                        </Button>
                    </Space.Compact>
                    
                    <Text type="secondary" style={{ fontSize: '0.9em' }}>
                        Output: /data/plab/runs
                        {availablePositions.length > 1 && !rbkPosition && (
                            <Text type="warning" style={{ marginLeft: 8 }}>— please select a position</Text>
                        )}
                    </Text>
                </Card>

                {data.error && (
                    <Alert
                        message="Error"
                        description={data.error}
                        type="error"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                )}

                {(serverId === 'a6000' ? basecallConfigsA6000 : serverId === 'mk1c' ? basecallConfigsMk1c : serverId === 'outpond' ? basecallConfigsOutpond : basecallConfigsSierra) && (
                    <Card 
                        title="Available Basecall Models" 
                        size="small" 
                        style={{ marginBottom: 16 }}
                        extra={
                            <Button 
                                size="small" 
                                onClick={() => serverId === 'a6000' ? setBasecallConfigsA6000(null) : serverId === 'mk1c' ? setBasecallConfigsMk1c(null) : serverId === 'outpond' ? setBasecallConfigsOutpond(null) : setBasecallConfigsSierra(null)}
                            >
                                Close
                            </Button>
                        }
                    >
                        {(() => {
                            const configs = serverId === 'a6000' ? basecallConfigsA6000 : serverId === 'mk1c' ? basecallConfigsMk1c : serverId === 'outpond' ? basecallConfigsOutpond : basecallConfigsSierra
                            const supModels = configs?.configs?.filter((c: any) => 
                                c.name?.includes('sup') && c.name?.includes('dna_r10.4.1_e8.2_400bps')
                            ) || []
                            
                            return (
                                <>
                                    {supModels.length > 0 && (
                                        <div style={{ marginBottom: 16 }}>
                                            <Text strong>Super Accuracy Models (DNA R10.4.1):</Text>
                                            <ul style={{ marginTop: 8 }}>
                                                {supModels.map((model: any, idx: number) => (
                                                    <li key={idx}>
                                                        <code>{model.name}</code>
                                                        {model.description && <Text type="secondary" style={{ marginLeft: 8 }}>- {model.description}</Text>}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    
                                    <details>
                                        <summary style={{ cursor: 'pointer' }}>All Available Models ({configs?.configs?.length || 0})</summary>
                                        <Button
                                            size="small"
                                            onClick={() => {
                                                navigator.clipboard.writeText(JSON.stringify(configs, null, 2))
                                                message.success('JSON copied to clipboard!')
                                            }}
                                            style={{ marginTop: 8, marginBottom: 8 }}
                                        >
                                            Copy JSON
                                        </Button>
                                        <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(configs, null, 2)}</pre>
                                    </details>
                                </>
                            )
                        })()}
                    </Card>
                )}

                {data.hostInfo && (
                    <Card title="Host Information" size="small" style={{ marginBottom: 16 }}>
                        <Descriptions bordered size="small" column={2}>
                            <Descriptions.Item label="Network Name">{data.hostInfo.network_name || 'N/A'}</Descriptions.Item>
                            <Descriptions.Item label="Can Basecall">{data.hostInfo.can_basecall || 'N/A'}</Descriptions.Item>
                            <Descriptions.Item label="Can Sequence Offline">
                                {data.hostInfo.can_sequence_offline ? 'Yes' : 'No'}
                            </Descriptions.Item>
                            <Descriptions.Item label="USB Device">
                                {data.hostInfo.can_connect_to_usb_device || 'N/A'}
                            </Descriptions.Item>
                            {data.hostInfo.current_basecalling_hardware?.gpus && data.hostInfo.current_basecalling_hardware.gpus.length > 0 && (
                                <Descriptions.Item label="Current GPUs" span={2}>
                                    {data.hostInfo.current_basecalling_hardware.gpus.join(', ')}
                                </Descriptions.Item>
                            )}
                            {data.hostInfo.product_code && (
                                <Descriptions.Item label="Product Code">{data.hostInfo.product_code}</Descriptions.Item>
                            )}
                            {data.hostInfo.serial && (
                                <Descriptions.Item label="Serial">{data.hostInfo.serial}</Descriptions.Item>
                            )}
                        </Descriptions>
                        <details style={{ marginTop: 12 }}>
                            <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                            <Button
                                size="small"
                                onClick={() => {
                                    navigator.clipboard.writeText(JSON.stringify(data.hostInfo, null, 2))
                                    message.success('JSON copied to clipboard!')
                                }}
                                style={{ marginTop: 8, marginBottom: 8 }}
                            >
                                Copy JSON
                            </Button>
                            <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(data.hostInfo, null, 2)}</pre>
                        </details>
                    </Card>
                )}

                {data.positions && (
                    <Card title="Positions" size="small" style={{ marginBottom: 16 }}>
                        {data.positions.filter((pos: any) => pos.state !== 'STATE_HARDWARE_REMOVED').map((pos: any, idx: number) => (
                            <Card.Grid key={idx} style={{ width: '100%' }}>
                                <Space>
                                    <Text strong>Position {pos.name}</Text>
                                    <Tag color={pos.state === 'STATE_RUNNING' ? 'green' : 'default'}>
                                        {pos.state || 'UNKNOWN'}
                                    </Tag>
                                    {pos.protocol_state && (
                                        <Tag color={
                                            pos.protocol_state === 'PROTOCOL_RUNNING' ? 'blue' :
                                            pos.protocol_state === 'PROTOCOL_FINISHED_SUCCESSFULLY' ? 'green' :
                                            pos.protocol_state === 'PROTOCOL_FINISHED_WITH_ERROR' ? 'red' :
                                            'default'
                                        }>
                                            {pos.protocol_state}
                                        </Tag>
                                    )}
                                </Space>
                            </Card.Grid>
                        ))}
                        <details style={{ marginTop: 12 }}>
                            <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                            <Button
                                size="small"
                                onClick={() => {
                                    navigator.clipboard.writeText(JSON.stringify(data.positions, null, 2))
                                    message.success('JSON copied to clipboard!')
                                }}
                                style={{ marginTop: 8, marginBottom: 8 }}
                            >
                                Copy JSON
                            </Button>
                            <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(data.positions, null, 2)}</pre>
                        </details>
                    </Card>
                )}

                {data.protocol && Array.isArray(data.protocol) && data.protocol.length > 0 && (
                    <Card title="Protocol Run Info" size="small" style={{ marginBottom: 16 }}>
                        {data.protocol.map((proto: any, idx: number) => (
                            <Card
                                key={idx}
                                type="inner"
                                title={`Position: ${proto.positionName}`}
                                size="small"
                                style={{ marginBottom: idx < data.protocol.length - 1 ? 12 : 0 }}
                            >
                                <Descriptions bordered size="small" column={1}>
                                    {proto.protocol_id && (
                                        <Descriptions.Item label="Protocol ID">{proto.protocol_id}</Descriptions.Item>
                                    )}
                                    {proto.run_id && (
                                        <Descriptions.Item label="Run ID">{proto.run_id}</Descriptions.Item>
                                    )}
                                    {proto.output_path && (
                                        <Descriptions.Item label="Output Path">{proto.output_path}</Descriptions.Item>
                                    )}
                                    {proto.state && (
                                        <Descriptions.Item label="State">
                                            <Tag color={proto.state === 'PROTOCOL_RUNNING' ? 'green' : 'default'}>
                                                {proto.state}
                                            </Tag>
                                        </Descriptions.Item>
                                    )}
                                </Descriptions>
                                <details style={{ marginTop: 12 }}>
                                    <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            navigator.clipboard.writeText(JSON.stringify(proto, null, 2))
                                            message.success('JSON copied to clipboard!')
                                        }}
                                        style={{ marginTop: 8, marginBottom: 8 }}
                                    >
                                        Copy JSON
                                    </Button>
                                    <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(proto, null, 2)}</pre>
                                </details>
                            </Card>
                        ))}
                    </Card>
                )}

                {data.acquisition && Array.isArray(data.acquisition) && data.acquisition.length > 0 && (
                    <Card title="Acquisition Info" size="small" style={{ marginBottom: 16 }}>
                        {data.acquisition.map((acq: any, idx: number) => (
                            <Card
                                key={idx}
                                type="inner"
                                title={`Position: ${acq.positionName}`}
                                size="small"
                                style={{ marginBottom: idx < data.acquisition.length - 1 ? 12 : 0 }}
                            >
                                <Descriptions bordered size="small" column={1}>
                                    {acq.run_id && (
                                        <Descriptions.Item label="Run ID">{acq.run_id}</Descriptions.Item>
                                    )}
                                    {(acq.reads_directory || acq.config_summary?.reads_directory) && (
                                        <Descriptions.Item label="Reads Directory">
                                            {acq.reads_directory || acq.config_summary?.reads_directory}
                                        </Descriptions.Item>
                                    )}
                                    {acq.state && (
                                        <Descriptions.Item label="State">
                                            <Tag color={acq.state === 'ACQUISITION_RUNNING' ? 'green' : acq.state === 'ACQUISITION_COMPLETED' ? 'blue' : 'default'}>
                                                {acq.state}
                                            </Tag>
                                        </Descriptions.Item>
                                    )}
                                    {acq.stop_reason && (
                                        <Descriptions.Item label="Stop Reason">{acq.stop_reason}</Descriptions.Item>
                                    )}
                                    {acq.yield_summary?.read_count !== undefined && (
                                        <Descriptions.Item label="Read Count">
                                            {acq.yield_summary.read_count.toLocaleString()}
                                        </Descriptions.Item>
                                    )}
                                    {acq.start_time && (
                                        <Descriptions.Item label="Hours Running">
                                            {(() => {
                                                const totalMinutes = Math.floor((Date.now() - (parseInt(acq.start_time.seconds) * 1000 + (acq.start_time.nanos || 0) / 1000000)) / (1000 * 60));
                                                const hours = Math.floor(totalMinutes / 60);
                                                const minutes = totalMinutes % 60;
                                                return `${hours}h ${minutes}m`;
                                            })()}
                                        </Descriptions.Item>
                                    )}
                                    {acq.target_run_until_criteria && (() => {
                                        const runtime = acq.target_run_until_criteria?.stop_criteria?.criteria?.runtime;
                                        if (runtime?.value?.data) {
                                            const runtimeData = runtime.value.data;
                                            let value = 0;
                                            let shift = 0;
                                            for (let i = 1; i < runtimeData.length; i++) {
                                                value |= (runtimeData[i] & 0x7F) << shift;
                                                if ((runtimeData[i] & 0x80) === 0) break;
                                                shift += 7;
                                            }
                                            const hours = (value / 3600).toFixed(2);
                                            return (
                                                <Descriptions.Item label="Run-until Criteria">
                                                    {hours} hours
                                                </Descriptions.Item>
                                            );
                                        }
                                        return null;
                                    })()}
                                </Descriptions>
                                {acq.bream_info?.mux_scan_results && acq.bream_info.mux_scan_results.length > 0 && (
                                    <div style={{ marginTop: 16, padding: '12px', backgroundColor: '#e6f7ff', borderRadius: '4px' }}>
                                        <Text strong style={{ marginBottom: 8, display: 'block' }}>Mux Scan Results - Single Pore Counts:</Text>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                            {acq.bream_info.mux_scan_results.map((result: any, i: number) => (
                                                <Tag key={i} color="green" style={{ margin: 0 }}>
                                                    {result.counts.single_pore}
                                                </Tag>
                                            ))}
                                        </div>
                                        <Text type="secondary" style={{ fontSize: '0.85em', marginTop: 8, display: 'block' }}>
                                            Total scans: {acq.bream_info.mux_scan_results.length} | 
                                            Latest: {acq.bream_info.mux_scan_results[acq.bream_info.mux_scan_results.length - 1]?.counts.single_pore} pores
                                        </Text>
                                    </div>
                                )}
                                <details style={{ marginTop: 12 }}>
                                    <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            navigator.clipboard.writeText(JSON.stringify(acq, null, 2))
                                            message.success('JSON copied to clipboard!')
                                        }}
                                        style={{ marginTop: 8, marginBottom: 8 }}
                                    >
                                        Copy JSON
                                    </Button>
                                    <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(acq, null, 2)}</pre>
                                </details>
                            </Card>
                        ))}
                        <div style={{ marginTop: 12, padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                            <Text strong style={{ marginBottom: 8, display: 'block' }}>Update Run-until:</Text>
                            <Space.Compact style={{ width: '100%' }}>
                                <Input
                                    type="number"
                                    step="0.1"
                                    min="0"
                                    placeholder="Hours (e.g., 3.5)"
                                    value={runUntilHours}
                                    onChange={(e) => setRunUntilHours(e.target.value)}
                                    style={{ width: '150px' }}
                                />
                                {availablePositions.length > 1 && (
                                    <Select
                                        placeholder="Select position"
                                        value={runUntilPosition || undefined}
                                        onChange={(val) => setRunUntilPosition(val)}
                                        style={{ width: '160px' }}
                                        options={availablePositions.map((p) => ({ label: p, value: p }))}
                                    />
                                )}
                                <Button
                                    icon={<ReloadOutlined />}
                                    onClick={() => handleUpdateRunUntil(serverId)}
                                    disabled={availablePositions.length > 1 && !runUntilPosition}
                                >
                                    Update Run-until
                                </Button>
                            </Space.Compact>
                        </div>
                    </Card>
                )}

                {(() => {
                    const allChannelStates = serverId === 'a6000' ? channelStatesA6000 : serverId === 'mk1c' ? channelStatesMk1c : serverId === 'outpond' ? channelStatesOutpond : channelStatesSierra
                    if (!allChannelStates || !Array.isArray(allChannelStates) || allChannelStates.length === 0) return null

                    const stateColor: Record<string, string> = {
                        strand: '#52c41a',
                        pore: '#1677ff',
                        adapter: '#69c0ff',
                        event: '#fadb14',
                        unblocking: '#fa8c16',
                        above: '#722ed1',
                        saturated: '#434343',
                        unavailable: '#bfbfbf',
                        unclassified: '#d9d9d9',
                        multiple: '#13c2c2',
                        zero: '#595959',
                        inactive: '#d9d9d9',
                    }

                    const cols = 32
                    const cellSize = 12
                    const gap = 1

                    return (
                        <Card
                            title="Channel States"
                            size="small"
                            style={{ marginBottom: 16 }}
                            extra={
                                <Button size="small" onClick={() => {
                                    if (serverId === 'a6000') setChannelStatesA6000(null)
                                    else if (serverId === 'mk1c') setChannelStatesMk1c(null)
                                    else if (serverId === 'outpond') setChannelStatesOutpond(null)
                                    else setChannelStatesSierra(null)
                                }}>Close</Button>
                            }
                        >
                            {allChannelStates.map((channelStates: any, posIdx: number) => {
                                const channelMap: Record<number, string> = {}
                                const rawStates: any[] = channelStates.channel_states ?? channelStates.states ?? []
                                rawStates.forEach((cs: any) => {
                                    const ch = cs.channel ?? cs.channel_number
                                    const st = (cs.state_name ?? cs.name ?? 'unclassified').toLowerCase()
                                    if (ch !== undefined) channelMap[ch] = st
                                })

                                const maxChannel = Math.max(512, ...Object.keys(channelMap).map(Number))
                                const totalChannels = maxChannel
                                const rows = Math.ceil(totalChannels / cols)

                                const stateCounts: Record<string, number> = {}
                                Object.values(channelMap).forEach(s => { stateCounts[s] = (stateCounts[s] || 0) + 1 })

                                return (
                                    <Card
                                        key={posIdx}
                                        type="inner"
                                        title={`Position: ${channelStates.positionName}`}
                                        size="small"
                                        style={{ marginBottom: posIdx < allChannelStates.length - 1 ? 12 : 0 }}
                                    >
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
                                            {Object.entries(stateColor).filter(([s]) => stateCounts[s]).map(([state, color]) => (
                                                <span key={state} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
                                                    <span style={{ width: 12, height: 12, background: color, display: 'inline-block', borderRadius: 2 }} />
                                                    {state} ({stateCounts[state] || 0})
                                                </span>
                                            ))}
                                        </div>
                                        <div style={{ overflowX: 'auto' }}>
                                            <svg
                                                width={cols * (cellSize + gap) - gap}
                                                height={rows * (cellSize + gap) - gap}
                                                style={{ display: 'block' }}
                                            >
                                                {Array.from({ length: totalChannels }, (_, i) => {
                                                    const ch = i + 1
                                                    const state = channelMap[ch] ?? 'unclassified'
                                                    const color = stateColor[state] ?? stateColor.unclassified
                                                    const col = i % cols
                                                    const row = Math.floor(i / cols)
                                                    const x = col * (cellSize + gap)
                                                    const y = row * (cellSize + gap)
                                                    return (
                                                        <rect key={ch} x={x} y={y} width={cellSize} height={cellSize} fill={color} rx={1}>
                                                            <title>Ch {ch}: {state}</title>
                                                        </rect>
                                                    )
                                                })}
                                            </svg>
                                        </div>
                                        <details style={{ marginTop: 12 }}>
                                            <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(JSON.stringify(channelStates, null, 2))
                                                    message.success('JSON copied to clipboard!')
                                                }}
                                                style={{ marginTop: 8, marginBottom: 8 }}
                                            >
                                                Copy JSON
                                            </Button>
                                            <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(channelStates, null, 2)}</pre>
                                        </details>
                                    </Card>
                                )
                            })}
                        </Card>
                    )
                })()}

                {data.flowcell && Array.isArray(data.flowcell) && data.flowcell.length > 0 && (
                    <Card title="Flowcell Info" size="small" style={{ marginBottom: 16 }}>
                        {data.flowcell.map((fc: any, idx: number) => (
                            <Card
                                key={idx}
                                type="inner"
                                title={`Position: ${fc.positionName}`}
                                size="small"
                                style={{ marginBottom: idx < data.flowcell.length - 1 ? 12 : 0 }}
                            >
                                <Descriptions bordered size="small" column={1}>
                                    {fc.has_flow_cell !== undefined && (
                                        <Descriptions.Item label="Has Flow Cell">
                                            {fc.has_flow_cell ? (
                                                <Tag color="green">Yes</Tag>
                                            ) : (
                                                <Tag color="red">No</Tag>
                                            )}
                                        </Descriptions.Item>
                                    )}
                                    {fc.flow_cell_id && (
                                        <Descriptions.Item label="Flow Cell Name">
                                            {fc.flow_cell_id}
                                        </Descriptions.Item>
                                    )}
                                    {fc.dbFlowcellId && (
                                        <Descriptions.Item label="Flow Cell ID">
                                            <Link to={`/admin/flowcell/${fc.dbFlowcellId}`}>
                                                <Tag color="blue" style={{ cursor: 'pointer' }}>#{fc.dbFlowcellId}</Tag>
                                            </Link>
                                        </Descriptions.Item>
                                    )}
                                    {fc.user_specified_product_code && (
                                        <Descriptions.Item label="Product Code">{fc.user_specified_product_code}</Descriptions.Item>
                                    )}
                                    {fc.channel_count !== undefined && (
                                        <Descriptions.Item label="Channel Count">{fc.channel_count}</Descriptions.Item>
                                    )}
                                </Descriptions>
                                <details style={{ marginTop: 12 }}>
                                    <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            navigator.clipboard.writeText(JSON.stringify(fc, null, 2))
                                            message.success('JSON copied to clipboard!')
                                        }}
                                        style={{ marginTop: 8, marginBottom: 8 }}
                                    >
                                        Copy JSON
                                    </Button>
                                    <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(fc, null, 2)}</pre>
                                </details>
                            </Card>
                        ))}
                    </Card>
                )}

                {data.flowcellCheckError && (
                    <Alert
                        message="Flowcell Check Error"
                        description={data.flowcellCheckError}
                        type="error"
                        showIcon
                        closable
                        onClose={() => updateData(serverId, { flowcellCheckError: null })}
                        style={{ marginBottom: 16 }}
                    />
                )}

                {data.flowcellCheckProgress && (
                    <Card 
                        title="Flowcell Check Progress" 
                        size="small" 
                        style={{ marginBottom: 16 }}
                        extra={
                            <Button 
                                size="small" 
                                onClick={() => updateData(serverId, { flowcellCheckProgress: null })}
                            >
                                Close
                            </Button>
                        }
                    >
                        {data.flowcellCheckProgress.state === 'PROTOCOL_RUNNING' && (
                            <Alert
                                message="⏳ Flowcell check is still running..."
                                type="info"
                                showIcon
                                style={{ marginBottom: 16 }}
                            />
                        )}
                        
                        {data.flowcellCheckProgress.pqc_result && (
                            <div style={{ marginBottom: 16 }}>
                                <Title level={5}>Quality Control Results</Title>
                                <Descriptions bordered size="small" column={1}>
                                    <Descriptions.Item label="Total Pore Count">
                                        <Text strong style={{ color: '#52c41a', fontSize: '16px' }}>
                                            {data.flowcellCheckProgress.pqc_result.total_pore_count?.toLocaleString() || 'N/A'}
                                        </Text>
                                    </Descriptions.Item>
                                    {data.flowcellCheckProgress.pqc_result.passed !== undefined && (
                                        <Descriptions.Item label="Passed">
                                            <Tag color={data.flowcellCheckProgress.pqc_result.passed ? 'green' : 'red'}>
                                                {data.flowcellCheckProgress.pqc_result.passed ? 'PASSED' : 'FAILED'}
                                            </Tag>
                                        </Descriptions.Item>
                                    )}
                                    {data.flowcellCheckProgress.pqc_result.flow_cell_id && (
                                        <Descriptions.Item label="Flow Cell Name">
                                            {data.flowcellCheckProgress.pqc_result.flow_cell_id}
                                        </Descriptions.Item>
                                    )}
                                </Descriptions>
                            </div>
                        )}

                        {data.flowcellCheckProgress.phase_history && data.flowcellCheckProgress.phase_history.length > 0 && (
                            <div style={{ marginBottom: 16 }}>
                                <Title level={5}>Phase History</Title>
                                {data.flowcellCheckProgress.phase_history.map((phase: any, idx: number) => (
                                    <div key={idx} style={{ marginBottom: 8 }}>
                                        <Text>
                                            <Tag color={phase.phase === 'completed' ? 'green' : 'blue'}>{phase.phase}</Tag>
                                            {phase.start_time && ` Started: ${new Date(phase.start_time * 1000).toLocaleString()}`}
                                        </Text>
                                    </div>
                                ))}
                            </div>
                        )}

                        <details>
                            <summary style={{ cursor: 'pointer' }}>Full JSON</summary>
                            <Button
                                size="small"
                                onClick={() => {
                                    navigator.clipboard.writeText(JSON.stringify(data.flowcellCheckProgress, null, 2))
                                    message.success('JSON copied to clipboard!')
                                }}
                                style={{ marginTop: 8, marginBottom: 8 }}
                            >
                                Copy JSON
                            </Button>
                            <pre style={{ fontSize: '0.85em', marginTop: 8 }}>{JSON.stringify(data.flowcellCheckProgress, null, 2)}</pre>
                        </details>
                    </Card>
                )}
            </>
        )
    }

    return (
        <ContainerFull>
            <style>{`
                @media (max-width: 768px) {
                    .acquisition-info-btn {
                        margin: 40px !important;
                        padding: 40px 40px !important;
                        min-height: 60px !important;
                    }
                }
            `}</style>
            <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12 }}>
                <Title level={2} style={{ margin: 0 }}>MinKNOWs</Title>
                <div style={{ display: 'flex', gap: 8 }}>
                    <img 
                        src={minnowImage} 
                        alt="minnow" 
                        style={{ height: 80, width: 120, objectFit: 'cover', borderRadius: 4 }}
                    />
                    <img 
                        src={minnowImage} 
                        alt="minnow" 
                        style={{ height: 80, width: 120, objectFit: 'cover', borderRadius: 4 }}
                    />
                     <img 
                        src={minnowImage} 
                        alt="minnow" 
                        style={{ height: 80, width: 120, objectFit: 'cover', borderRadius: 4 }}
                    />
                     <img 
                        src={minnowImage} 
                        alt="minnow" 
                        style={{ height: 80, width: 120, objectFit: 'cover', borderRadius: 4 }}
                    />
                </div>
            </div>

            <Tabs 
                activeKey={activeTab} 
                onChange={(key) => setActiveTab(key as 'a6000' | 'mk1c' | 'outpond' | 'sierra')}
                items={[
                    {
                        key: 'a6000',
                        label: 'a6000',
                        children: renderServerTab('a6000')
                    },
                    {
                        key: 'mk1c',
                        label: 'mk1c',
                        children: renderServerTab('mk1c')
                    },
                    {
                        key: 'outpond',
                        label: 'outpond',
                        children: renderServerTab('outpond')
                    },
                    {
                        key: 'sierra',
                        label: 'Sierra',
                        children: renderServerTab('sierra')
                    }
                ]}
            />
        </ContainerFull>
    )
}

export default MinKnow
